import React, { useEffect, useRef, useState } from 'react';
import { Row, Col } from 'react-bootstrap';

import governmentIcon from './Images/Government.png';
import d2cIcon from './Images/D2C brand.png';
import healthcareIcon from './Images/Healthcare.png';
import educationIcon from './Images/Education.png';
import agricultureIcon from './Images/Agriculture.png';
import smartCitiesIcon from './Images/SmartCities.png';

const useCases = [
  {
    icon: governmentIcon,
    title: 'Government',
    desc: 'Citizen engagement, Complaint handling, Document flow.',
    alt: 'Government Sector Icon'
  },

  {
    icon: d2cIcon,
    title: 'D2C brand',
    desc: 'Order tracking, Catalog selling, Payment reminders.',
    alt: 'D2C Brand Icon'
  },

  {
    icon: healthcareIcon,
    title: 'Healthcare',
    desc: 'Appointment booking, Prescriptions, Reports on WhatsApp.',
    alt: 'Healthcare Icon'
  },

  {
    icon: educationIcon,
    title: 'Education',
    desc: 'Admission queries, Results, Learning materials delivery.',
    alt: 'Education Icon'
  },

  {
    icon: agricultureIcon,
    title: 'Agriculture',
    desc: 'Farmer onboarding, mandi pricing, buy/sell produce.',
    alt: 'Agriculture Icon'
  },

  {
    icon: smartCitiesIcon,
    title: 'Smart Cities', desc: 'Feedback collection, Service alerts, Utility updates.',
    alt: 'Smart Cities Icon'
  },
];

const UseCasesHero = () => {
  const sectionRef = useRef(null);
  const [seen, setSeen] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setSeen(true);
            io.unobserve(el);
          }
        });
      },
      { root: null, threshold: 0.15 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  // index-based direction: 0,3 -> left | 1,4 -> down | 2,5 -> right
  const dirClass = (i) => {
    if (i % 3 === 0) return 'reveal-left';
    if (i % 3 === 1) return 'reveal-down';
    return 'reveal-right';
  };

  return (
    <section ref={sectionRef} className="py-5 position-relative" style={{ overflow: 'hidden' }}>
      <div className="px-5 x-xxl-5 px-6 mx-auto position-relative" style={{ maxWidth: '74%', zIndex: 1 }}>
        {/* Heading */}
        <div className={`mb-5 ${seen ? 'reveal-down' : 'pre'}`} style={{ marginTop: '68px' }}>
          <h2
            style={{
              fontSize: '44px',
              fontFamily: "'Inter', sans-serif",
              fontWeight: 650,
              color: '#1C1C1C',
              lineHeight: 1.2,
            }}
          >
            Build for every industry,
            <br />
            Made to scale
          </h2>
        </div>

        {/* Cards */}
        <Row className="g-4">
          {useCases.map((item, index) => (
            <Col key={index} xs={12} sm={6} md={4} className={seen ? dirClass(index) : 'pre'}>
              <div
                className="h-100 p-4"
                style={{
                  background: 'linear-gradient(135deg, #dce7faff, #fefefeff)',
                  borderRadius: '16px',
                  border: '1px solid #dae6fcff',
                  backdropFilter: 'blur(14px)',
                  backgroundBlendMode: 'overlay',
                  boxShadow: '0 8px 16px rgba(0, 0, 0, 0.03)',
                  transition: 'transform 0.3s ease',
                }}
              >
                <div className="d-flex flex-column align-items-start">
                  {/* Icon Box */}
                  <div
                    style={{
                      height: '68px',
                      width: '68px',
                      borderRadius: '12px',
                      backgroundColor: '#FFFFFF',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginBottom: '16px',
                    }}
                  >
                    <img
                      src={item.icon}
                      alt={item.alt}
                      width="36"
                      height="36"
                      loading="lazy"
                      style={{ objectFit: 'contain' }}
                    />
                  </div>

                  {/* Title */}
                  <h5
                    style={{
                      fontSize: '22px',
                      fontFamily: "'Inter', sans-serif",
                      fontWeight: 600,
                      color: '#000C2D',
                      marginBottom: '8px',
                    }}
                  >
                    {item.title}
                  </h5>

                  {/* Description */}
                  <p
                    style={{
                      fontSize: '17px',
                      fontFamily: "'Inter', sans-serif",
                      fontWeight: 400,
                      color: '#404040',
                      lineHeight: 1.2,
                      margin: 0,
                    }}
                  >
                    {item.desc}
                  </p>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>

      {/* Animation CSS */}
      <style>{`
        .pre { opacity: 0; }

        /* Heading: fade from top */
        @keyframes fadeDown {
          0% { opacity: 0; transform: translateY(-16px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        .reveal-down { animation: fadeDown 800ms ease-out both; }

        /* Cards: left / right / up */
        @keyframes fadeLeftIn {
          0% { opacity: 0; transform: translateX(-20px); }
          100% { opacity: 1; transform: translateX(0); }
        }
        @keyframes fadeRightIn {
          0% { opacity: 0; transform: translateX(20px); }
          100% { opacity: 1; transform: translateX(0); }
        }
        @keyframes fadeUpIn {
          0% { opacity: 0; transform: translateY(18px); }
          100% { opacity: 1; transform: translateY(0); }
        }

        .reveal-left  { animation: fadeLeftIn 900ms ease-out both; }
        .reveal-right { animation: fadeRightIn 900ms ease-out both; }
        .reveal-down  { animation: fadeDown 800ms ease-out both; }

        /* For center cards (2nd & 5th), fade-up from top instruction: 
           The content should come from top? Your text says "tops smoothly fade"; 
           Typically "from top" -> fadeDown. If you want "fade-up" feel, use below: */
        .reveal-up    { animation: fadeUpIn 900ms ease-out both; }
        
      `}</style>
    </section>
  );
};

export default UseCasesHero;

